// const Parallax = require('./vendor/parallax.3.1.0');
import simpleParallax from 'simple-parallax-js'
import axios from 'axios/dist/axios'
import 'vanilla-hamburger/fade-burger.js'
import { groupedImagesOnDocument } from './grouped-images'
// import * as Turbo from '@hotwired/turbo'

const Turbo = null

import { markElementsRelativeFromCurrentCenteredViewOnScrollThrottled } from './markElementsRelativeFromCurrentCenteredView'

function matomo() {
  let allow = localStorage.getItem('matomo') === 'true'
  if (!allow) {
    console.info('Not embedding matomo.')
  }
  var _paq = (window._paq = window._paq || [])
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView'])
  _paq.push(['enableLinkTracking'])
  ;(function () {
    var u = 'https://bppphotograpy.matomo.cloud/'
    _paq.push(['setTrackerUrl', u + 'matomo.php'])
    _paq.push(['setSiteId', '1'])
    var d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0]
    g.async = true
    g.src = '//cdn.matomo.cloud/bppphotograpy.matomo.cloud/matomo.js'
    s.parentNode.insertBefore(g, s)
  })()
}

function facebookPixel() {
  let allow = localStorage.getItem('fb-pixel') === 'true'
  const meta_pixel_id = '477955506711472'
  if (!allow) {
    console.info('Not embedding meta pixel.')
  } else {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    )
    fbq('init', meta_pixel_id)
    fbq('track', 'PageView')
  }
}

// const DOMReady = function (callback) {
//   document.readyState === 'interactive' || document.readyState === 'complete'
//     ? callback()
//     : document.addEventListener(Turbo ? 'turbo:load' : 'DOMContentLoaded', callback);
// };

const isPhone = () => window.window.innerWidth < 768

function setCookie(name, value, days, opts) {
  if (!opts) {
    opts = {
      path: '/',
    }
  }
  opts['max-age'] = days * 60 * 60 * 24
  opts = Object.entries(opts).reduce(
    (accumulatedStr, [k, v]) => `${accumulatedStr}; ${k}=${v}`,
    ''
  )
  document.cookie =
    name + '=' + encodeURIComponent(JSON.stringify(value)) + opts + '; Secure'
}

function deleteCookie(name) {
  document.cookie =
    name +
    '=; Path=/;  Domain=' +
    location.host +
    '; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=None; Secure'
}

function getCookie(cookieKey) {
  let cookieContent = document.cookie.match(
    `(?:(?:^|.*; *)${cookieKey} *= *([^;]*).*$)|^.*$`
  )[1]
  return cookieContent ? JSON.parse(decodeURIComponent(cookieContent)) : null
}

const loadParallax = () => {
  let additionalFilter = isPhone() ? ':not(.not-for-phone)' : ''
  let query = `img[data-scale].parallax${additionalFilter}, figure[data-scale].parallax${additionalFilter}, div[data-scale].parallax.container${additionalFilter}`
  ;[...document.querySelectorAll(query)].forEach((el) => {
    new simpleParallax(el, {
      scale: el.dataset.scale,
      // delay: .1,
      overflow: true,
    })
  })
  if (isPhone()) {
    document
      .querySelectorAll('section.sponsors ul, section.partners ul')
      .forEach((el) => {
        new simpleParallax(el, {
          scale: 10,
          overflow: true,
          orientation: 'left',
          // delay: .2,
          // transition: 'cubic-bezier(0,0,0,2)',
        })
      })
  }

  if (!isPhone()) {
    ;[
      ...document.querySelectorAll(
        `.layout .block-call2Action .picture, .layout .parallax`
      ),
    ].forEach((el) => {
      new simpleParallax(el, {
        scale: el.dataset.scale || 1.5,
        overflow: true,
      })
    })
  }
}

const loadMorePortfoliosIfReachedBottom = (fn) => {
  window.onscroll = () => {
    let d = document.documentElement
    let offset = d.scrollTop + window.innerHeight
    let height = d.offsetHeight
    let padding = 400

    if (offset >= height - padding) {
      fn()
    }
  }
}

const searchProfilesAndLoadResults = async (replace = false, page = null) => {
  let query = [...new FormData(document.querySelector('form.search-form'))]
  let values = []

  for (const [name, value] of query) {
    if (name === 'page' && page > 0) {
      continue
    }
    if (value === '') {
      continue
    }
    values.push(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`)
  }
  if (page > 0) {
    values.push(`${encodeURIComponent('page')}=${encodeURIComponent(page)}`)
  }

  let queryString = values.join('&')
  let searchResults = document.querySelector('.search-results ul')
  searchResults.classList.add('loading')

  if (replace) {
    searchResults.classList.add('replacing')
  }

  let res = await axios.get(`${document.location.pathname}?${queryString}`)
  let data = document.createElement('response')
  data.innerHTML = res.data
  let searchResultHTML = data.querySelector('.search-results ul').innerHTML
  if (searchResultHTML.trim() === '') {
    searchResults.classList.add('no-more-results')
  } else {
    if (replace) {
      searchResults.innerHTML = searchResultHTML
    } else {
      searchResults.innerHTML = searchResults.innerHTML + searchResultHTML
    }
  }
  searchResults.classList.remove('loading')
  searchResults.classList.remove('replacing')
  document.querySelector('.search-results').classList.remove('loading')
  searchResults.dataset.page = page || 1
}

const searchForm = () => {
  let searchForm = document.querySelector('form.search-form')
  document
    .querySelectorAll('form.search-form input[type="radio"]')
    .forEach((el) =>
      el.addEventListener('change', () => {
        searchForm
          .querySelectorAll('.area.expanded')
          .forEach((el) => el.classList.remove('expanded'))
      })
    )
  searchForm.addEventListener('change', async () => {
    await searchProfilesAndLoadResults(true)
  })
  searchForm.addEventListener('submit', (ev) => ev.preventDefault())

  loadMorePortfoliosIfReachedBottom(async () => {
    let searchResults = document.querySelector('.search-results ul')
    if (!searchResults || searchResults.classList.contains('no-more-results')) {
      return
    }
    if (document.querySelector('.search-results:not(.loading)')) {
      document.querySelector('.search-results').classList.add('loading')
      searchResults.classList.add('loading')
      let page = searchResults.dataset.page || 1
      page = Number(page) + 1
      //let query = new URLSearchParams(window.location.search).get('query');
      // let queryString = serializeForm(document.querySelector('form.search-form'));
      await searchProfilesAndLoadResults(false, page)
    }
  })
}

const DOMReady = function () {
  loadParallax()

  if (
    document.querySelector(
      '.portfolios-template .search-results ul, .ipqs-template .search-results ul'
    )
  ) {
    searchForm()
  }

  if (!getCookie('cookieConsentSet')) {
    document.querySelector('body').classList.add('show-cookie-banner')
  }

  document
    .querySelectorAll('form.form input[required][placeholder]')
    .forEach((el) => {
      el.placeholder = el.placeholder.replace(/(\s*\*\s*)*$/, ' *')
    })

  document
    .querySelector('.mobile-navigation .toggle-close-open')
    .addEventListener('click', (ev) => {
      document.querySelector('header .main-navigation').classList.toggle('open')
      document.querySelector('body').classList.toggle('navigation-is-open')
      // document.querySelector('body').classList.toggle('mobile-navigation-open')
    })

  document.querySelectorAll('.typography .more').forEach((el) => {
    el.addEventListener('click', (ev) => el.classList.toggle('expanded'))
  })

  document
    .querySelectorAll('.search-filters .toggle-filter .control')
    .forEach((el) => {
      el.addEventListener('click', (ev) =>
        el.closest(el.dataset.target).classList.toggle('expanded')
      )
    })

  document
    .querySelectorAll(
      '.portfolio-galleries .gallery ul, .ipq-galleries .gallery ul'
    )
    .forEach((galleries) => {
      if (isPhone()) {
        return
      }
      if (!galleries.querySelector('li')) {
        return
      }
      markElementsRelativeFromCurrentCenteredViewOnScrollThrottled(
        galleries,
        'li',
        'horizontal'
      )
    })

  let portfolioSearchForm = document.querySelector(
    '.portfolios-template .search-form form, .ipqs-template .search-form form'
  )

  if (portfolioSearchForm) {
    portfolioSearchForm.addEventListener('submit', (ev) => {
      // ev.preventDefault();
      document.querySelector('.search-results').classList.add('loading')
    })
  }

  document.querySelectorAll('.gallery ul').forEach((el) => {
    setTimeout(function () {
      el.scrollTo({
        left: 0,
        behavior: 'smooth',
      })
    }, 1000)
  })

  document
    .querySelector('#sticky-modal .close')
    ?.addEventListener('click', () => {
      let modal = document.querySelector('#sticky-modal')
      modal.classList.remove('visible')
      modal.querySelector('.content').innerHTML = ''
    })
  window.showVideoModal = function (e, url) {
    // url = decodeURI(url)
    let html = ``
    let overlay = document.querySelector('#sticky-modal')
    let content = overlay.querySelector(`.content`)
    url = url.replace(/((player|www)\.)*vimeo\.com/, 'player.vimeo.com')
    if (url.match('youtube.com')) {
      html = `
      <iframe width="560" height="315" src="${url}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      `
      overlay.classList.add('youtube')
    } else if (url.match('vimeo.com')) {
      overlay.classList.add('vimeo')
      html = `
      <iframe src="${url}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
      `
    }
    content.innerHTML = html
    document.querySelector('#sticky-modal').classList.add('visible')
  }

  document.querySelectorAll('.gallery li img').forEach((el) => {
    if (isPhone()) {
      return
    }
  })

  document.querySelectorAll('a[href^="http"]').forEach((el) => {
    if (
      !el.getAttribute('href') ||
      el.getAttribute('target') ||
      /:\/\/(www\.)*bpp\.photography/.test(el.getAttribute('href')) ||
      el
        .getAttribute('href')
        .startsWith(
          document.location.protocol + '//' + document.location.hostname
        )
    ) {
      return
    }
    el.setAttribute('target', '_blank')
  })

  // no -> for images inside an <a> tag
  document.querySelectorAll('.typography a img').forEach((el) => {
    el.closest('a').classList.add('no-arrow')
  })

  document
    .querySelectorAll(
      '.centered-image-slider .arrow-left, .centered-image-slider .arrow-right, .gallery .gallery-slider .arrow-left, .gallery .gallery-slider .arrow-right'
    )
    .forEach((el) => {
      el.addEventListener('click', (ev) => {
        let parent = ev.currentTarget.closest('.gallery, .box')
        let endless = parent.classList.contains('endless')
        let slideContainer = parent.querySelector('ul')
        parent.querySelectorAll('.arrow-left, .arrow-right').forEach(el => el.classList.remove('disabled'))
        slideContainer.classList.add('changed')
        let direction = ev.currentTarget.classList.contains('arrow-left')
          ? -1
          : 1
        let scrollToElement = slideContainer.querySelector('li')
        let left =
          slideContainer.scrollLeft + direction * scrollToElement.clientWidth
        if (endless) {
          let slidesWidth = [...slideContainer.querySelectorAll('li')]
            .map((e) => e.clientWidth)
            .reduce((r, i) => r + i)
          if (left < 0) {
            left = slidesWidth
          } else if (left >= slidesWidth) {
            left = 0
          }
        }
        slideContainer.scrollTo({
          left,
          behavior: 'smooth',
        })
      })
    })

    /*
     * new slider element (2024)
     *
     */
  document
    .querySelectorAll('.block .arrow-right, .block .arrow-left')
    .forEach((el) => {
      let slideContainer = el.closest('.block').querySelector('.slides')
      let currentSlide = slideContainer.querySelector(':scope > *:first-child')
      currentSlide.classList.add('current')

      el.addEventListener('click', (ev) => {
        currentSlide = slideContainer.querySelector(':scope > .current')
        let nextSlide = null
        let reachedEndOfScrollContainer =
          slideContainer.scrollLeft + slideContainer.clientWidth + 1 >=
          slideContainer.scrollWidth
        if (ev.currentTarget.classList.contains('arrow-right')) {
          nextSlide =
            currentSlide.nextElementSibling ||
            slideContainer.querySelector(':scope > *:first-child')
          if (reachedEndOfScrollContainer) {
            nextSlide = slideContainer.querySelector(':scope > *:first-child')
          }
        } else {
          nextSlide =
            currentSlide.previousElementSibling ||
            slideContainer.querySelector(':scope > *:last-child')
          if (reachedEndOfScrollContainer) {
            // take first invisible
            nextSlide = [...slideContainer.querySelectorAll(':scope > *')]
              .filter((el) => el.offsetLeft < slideContainer.scrollLeft)
              .sort((a, b) => b.offsetLeft - a.offsetLeft)[0]
          }
        }

        currentSlide.classList.remove('current')
        nextSlide.classList.add('current')

        slideContainer.scrollTo({
          left: nextSlide.offsetLeft,
          behavior: 'smooth',
        })
      })
    })

  // require('./grouped-images')
  groupedImagesOnDocument();
}

window.addEventListener('load', (event) => {
  if (isPhone()) {
    return
  }
  document
    .querySelectorAll(
      '.centered-image-slider ul:not(.changed), .gallery .gallery-slider ul:not(.changed), .block-heroSlider .slides:not(.changed)'
    )
    .forEach((el) => {
      el.closest('.gallery, .box').querySelector('.arrow-left').classList.add('disabled')
      el.scrollTo({
        left: 0,
        behavior: 'smooth',
      })
    })
})

window.submitCookiePreferences = function () {
  let matomo = document.getElementById('cookie-matomo').checked
  let facebookPixel = document.getElementById('cookie-facebookpixel').checked
  localStorage.setItem('fb-pixel', facebookPixel ? 'true' : 'false')
  localStorage.setItem('matomo', matomo ? 'true' : 'false')
  setCookie('cookieConsentSet', true, 30)
  document.querySelector('body').classList.remove('show-cookie-banner')
}

if (window.location.hash === '#resetCookiePreferences') {
  localStorage.removeItem('fb-pixel')
  localStorage.removeItem('matomo')
  setCookie('cookieConsentSet', false, 30)
  console.info('Resets cookie preferences')
} else {
  facebookPixel()
  matomo()
}

document.addEventListener(Turbo ? 'turbo:load' : 'DOMContentLoaded', DOMReady)
